//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHoverBg: false,
            puzzles: [
                {
                    image: 'w4d5statistician.png',
                    x: 511,
                    y: 530,
                    width: 116,
                    height: 111,
                    correctDropAreaIndex: 0,
                    dropAreaIndex: -1
                },
                {
                    image: 'w4d5psychologist.png',
                    x: 675,
                    y: 515,
                    width: 126,
                    height: 150,
                    correctDropAreaIndex: 2,
                    dropAreaIndex: -1
                },
                {
                    image: 'w4d5sportsscientist.png',
                    x: 850,
                    y: 520,
                    width: 156,
                    height: 134,
                    correctDropAreaIndex: 1,
                    dropAreaIndex: -1
                },
                {
                    image: 'w4d5prothesistechnician.png',
                    x: 1050,
                    y: 530,
                    width: 108,
                    height: 133,
                    correctDropAreaIndex: 3,
                    dropAreaIndex: -1
                }
            ],
            dropAreas: [
                {
                    xMin: 380,
                    xMax: 567,
                    yMin: 182,
                    yMax: 488
                },
                {
                    xMin: 586,
                    xMax: 773,
                    yMin: 182,
                    yMax: 488
                },
                {
                    xMin: 788,
                    xMax: 975,
                    yMin: 182,
                    yMax: 488
                },
                {
                    xMin: 993,
                    xMax: 1177,
                    yMin: 182,
                    yMax: 488
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.puzzles.filter(puzzle => puzzle.correctDropAreaIndex === puzzle.dropAreaIndex).length;

            return this.$game.getDragDropResult(numCorrect, this.puzzles.length - numCorrect);
        }
    },

    methods: {
        dragend (puzzle, { x, y }) {
            this.showHoverBg = false;

            puzzle.x = x;
            puzzle.y = y;
            puzzle.dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                puzzle.x >= area.xMin - puzzle.width / 2 &&
                puzzle.x <= area.xMax - puzzle.width / 2 &&
                puzzle.y >= area.yMin - puzzle.height / 2 &&
                puzzle.y <= area.yMax - puzzle.height / 2
            );

            if (puzzle.dropAreaIndex !== -1) {
                this.$nextTick(() => {
                    puzzle.x = this.dropAreas[puzzle.dropAreaIndex].xMin + 100 - puzzle.width / 2;
                    puzzle.y = 290;
                });
            }
        }
    }
};
